const getAuthUser = () => localStorage.hasOwnProperty('algoDriven-authUser') ? JSON.parse(localStorage.getItem('algoDriven-authUser')) : null;
const setAuthUser = authUser => localStorage.setItem('authUser', JSON.stringify(authUser));

const getUserUid = () => localStorage.hasOwnProperty('algoDriven-authUser') ? getAuthUser().uid : null;
const getUserRole = () => localStorage.hasOwnProperty('algoDriven-authUser') ? getAuthUser().role : null;

const hasAcceptPolicy = () => getAuthUser() ? getAuthUser().acceptPolicy : false;


export {getUserUid, getAuthUser, hasAcceptPolicy, setAuthUser, getUserRole};